import { VariableType } from 'json-to-graphql-query';
export const LoginWithDeviceVariables = {
    login: 'String!',
    password: 'String!',
    deviceInput: 'DeviceInput',
    rememberMe: 'Boolean'
};
export const LoginWithDeviceArgs = {
    login: new VariableType('login'),
    password: new VariableType('password'),
    deviceInput: new VariableType('deviceInput'),
    rememberMe: new VariableType('rememberMe')
};
//# sourceMappingURL=loginWithDevice.js.map